import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartConnector } from '@b2b/features/cart/core/cart.connector';
import { CartService } from '@b2b/features/cart/core/cart.service';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs';

@Component({
  selector: 'mini-cart',
  imports: [CommonModule, RouterModule],
  templateUrl: './mini-cart.component.html',
  styleUrl: './mini-cart.component.scss',
})
export class MiniCartComponent implements OnInit {
  cart$ = this.cartService.getCart();

  credit$ = this.cartService.getCart().pipe(
    map(cart => cart.data?.b2BUnitCode),
    filter(Boolean),
    distinctUntilChanged(),
    switchMap(() => this.cartConnector.getAvailableCredit()),
  );

  constructor(
    private cartService: CartService,
    private cartConnector: CartConnector,
  ) {}

  ngOnInit(): void {
    const cartID = this.cartService.getCartID();
    if (cartID) {
      this.cartService.fetchMiniCart(cartID);
    }
  }
}
